<template>
  <div id="loading">
    Loading
  </div>
</template>

<script>

import {mapGetters} from 'vuex'

export default {
  name: 'Loading',
}
</script>

<style lang="scss">
  #loading{
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 150;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0;
    left: 0;
    font-family: var(--conduitITC);
    font-size: 1.8rem;
    font-weight: 600;
    text-transform: uppercase;
    color: var(--black);
  }
</style>



// WEBPACK FOOTER //
// src/components/Loading.vue